import styled from 'styled-components';

export const ListingSection = styled.div`
  width: 300px;
  float: right;
  background: #fff;
  margin-right: -300px;
  -webkit-transition: 0.5s ease-in-out margin 0.01s;
  transition: 0.3s ease-in-out margin 0.01s;
  box-shadow: 0px 2px 6px #aaa;
  z-index: 11;
  position: relative;
  &.openedState {
    margin-right: 0px;
  }
`;

export const TopBannerSection = styled.div`
  height: 60px;
  width: 100%;
  padding: 15px;
  color: #fff;
  background-color: rgba(104, 8, 227, 0.5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  & .flagIcon {
    border-radius: 30px;
  }
  &.closed {
    background: linear-gradient(270deg, #e63148 0%, #b50017 100%);
  }
  &.open {
    background: linear-gradient(90deg, #0c8149 0%, #19bf70 100%);
  }
  &.partiallyOpen {
    background: linear-gradient(90deg, #d85105 0%, #fc722e 100%);
  }
`;

export const SortBySection = styled.div`
  padding: 10px 25px;
  border-bottom: 1px solid #ddd;
  & .sortByarrow {
    border: solid #2276e3;
    border-width: 0 0px 2px 2px;
    display: inline-block;
    padding: 2px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    content: '';
    position: relative;
    right: -1px;
    top: -1px;
  }
  & .sortByoverlaybg {
    background: rgba(0, 0, 0, 0);
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 11;
  }
  & .sortByoptions {
    background: #fff;
    padding: 5px 10px;
    list-style-type: none;
    box-shadow: 0px 0px 6px #ddd;
    position: absolute;
    z-index: 1;
    right: -10px;
    top: -10px;
    border-radius: 6px;
    & li {
      padding: 5px 0;
      cursor: pointer;
      font-weight: 700;
      &.active {
        color: #2276e3;
      }
    }
  }
  & .backBtn {
    cursor: pointer;
    text-transform: uppercase;
  }
  & .backBtn .arrow {
    border: solid #0b69e3;
    border-width: 2px 0px 0px 2px;
    display: inline-block;
    padding: 2px;
    -webkit-transform: rotate(-45de);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    content: '';
  }
`;

export const Container = styled.div`
  height: calc(100vh - 246px);
  overflow-y: auto;
`;

export const ListingOuter = styled.div`
  background: #fff;
  & .viewAllfliBtn {
    background: #f16824;
    border-radius: 80px;
    color: #fff;
    padding: 8px 17px;
    font-size: 12px;
    text-transform: uppercase;
    display: inline-block;
  }
`;

export const CarrierLogo = styled.img`
  max-width: 100%;
  max-height: 25px;
  padding-right: ${props => props.theme.spacing.small};
`;

export const ListWrap = styled.div`
  padding: 20px;
  cursor: pointer;
  border-bottom: 1px solid #e1e7ee;
  & .loadingShimmerSquare {
    width: 20px;
    height: 20px;
    background: #8e93ab;
    opacity: 0.1;
    border-radius: 2px;
  }
  & .loadingSmallSquare {
    width: 14px;
    height: 14px;
    background: #8e93ab;
    opacity: 0.1;
    border-radius: 2px;
  }
  & .loadingShimmer {
    background: #8e93ab;
    opacity: 0.1;
    height: 8px;
    border-radius: 4px;
    &.height18 {
      height: 18px;
    }
  }
  & :last-child {
    border: none;
  }
  & .pricing {
    color: #0b69e3;
    font-size: 14px;
    font-weight: 700;
    position: relative;
  }
  & .arrow {
    border: solid #0b69e3;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 2px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    content: '';
    position: absolute;
    right: -5px;
    top: 6px;
  }
`;
